// frontend/src/api/subcategories.ts
import api from './axios';
import {
    Subcategory,
    CreateSubcategoryRequest,
    UpdateSubcategoryRequest
} from '../types/subcategory';

export async function getSubcategories(): Promise<Subcategory[]> {
    const res = await api.get<Subcategory[]>('/subcategories');
    return res.data;
}

export async function createSubcategory(
    data: CreateSubcategoryRequest
): Promise<Subcategory> {
    const res = await api.post<Subcategory>('/subcategories', data);
    return res.data;
}

export async function updateSubcategory(
    id: string,
    data: UpdateSubcategoryRequest
): Promise<Subcategory> {
    const res = await api.patch<Subcategory>(`/subcategories/${id}`, data);
    return res.data;
}

export async function deleteSubcategory(id: string): Promise<void> {
    await api.delete(`/subcategories/${id}`);
}
